'use strict';
salesTaxRefundController.$inject = ['$scope', '$q', '$interval', 'dialogHelper', 'reportHelper', 'accountStructureService', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('salesTaxRefundController', salesTaxRefundController);

function salesTaxRefundController($scope, $q, $interval, dialogHelper, reportHelper, accountStructureService, BUSY_MESSAGE) {
	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.loadingPromise = $q.all([$scope.vm.loadAccountStructures($scope.vm)]);

	function getViewModel() {
		var model = {
			message: BUSY_MESSAGE.Loading,
			report: {
				dateFrom: moment().toDate(),
				dateTo: moment().toDate(),
				reportType: 'Detail',
				groupElement: null,
				detailSortBy: 'CFE',
			},
			elements: [],
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (!model.report.dateFrom) {
				model.validationErrors.push("Please select a 'From' date.");
				isValid = false;
			}

			if (!model.report.dateTo) {
				model.validationErrors.push("Please select a 'To' date.");
				isValid = false;
			}

			if (isValid === true && moment(model.report.dateFrom).startOf('day') > moment(model.report.dateTo).startOf('day')) {
				model.validationErrors.push('Date Range is invalid!');
				isValid = false;
			}

			if (model.report.reportType === 'Detail_Summary' || model.report.reportType === 'Detail') {
				if (!model.report.groupElement || model.report.groupElement.length === 0) {
					model.validationErrors.push('Please select a valid Element.');
					isValid = false;
				}
			}

			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Sales Tax Refund Report Error!', null, model.validationErrors);
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var sortBy = '';
			if (model.report.reportType === 'Detail_Summary' || model.report.reportType === 'Detail') {
				sortBy = model.report.detailSortBy;
			} else {
				sortBy = model.report.reportType === 'Summary_Vendor' ? 'Vendor' : model.report.reportType === 'Summary_Date' ? 'Date' : 'County';
			}

			var report = {
				ReportType: model.report.reportType,
				DateFrom: moment(model.report.dateFrom).format('l'),
				DateTo: moment(model.report.dateTo).format('l'),
				SortBy: sortBy,
				GroupElementName: model.report.groupElement,
			};

			reportHelper.getReport($scope, '/api/fundreports/salestaxrefundreport', report, 'SalesTaxRefundReport.pdf');
		}

		function exportExcel(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Sales Tax Refund Report Error!', null, model.validationErrors);
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var sortBy = '';
			if (model.report.reportType === 'Detail_Summary' || model.report.reportType === 'Detail') {
				sortBy = model.report.detailSortBy;
			} else {
				sortBy = model.report.reportType === 'Summary_Vendor' ? 'Vendor' : model.report.reportType === 'Summary_Date' ? 'Date' : 'County';
			}

			var report = {
				ReportType: model.report.reportType,
				DateFrom: moment(model.report.dateFrom).format('l'),
				DateTo: moment(model.report.dateTo).format('l'),
				SortBy: sortBy,
				GroupElementName: model.report.groupElement,
			};

			reportHelper.getExcel($scope, '/api/fundreports/salestaxrefundexcel', report, 'SalesTaxRefund.xlsx');
		}

		function loadAccountStructures(model) {
			return accountStructureService.getStructure().then(finishLoadingAccountStructures);

			function finishLoadingAccountStructures(response) {
				if (response.data.accountStructure.UnifiedElementMap !== null) {
					model.elements = response.data.accountStructure.UnifiedElementMap.split('.');
					// remove the Fund element
					model.elements.splice(response.data.accountStructure.UnifiedElementFundIndex, 1);
				} else {
					let assetElements = response.data.accountStructure.AssetElementMap.split('.');
					assetElements.splice(response.data.accountStructure.AssetElementFundIndex, 1);
					let liabilityElements = response.data.accountStructure.LiabilityElementMap.split('.');
					liabilityElements.splice(response.data.accountStructure.LiabilityElementFundIndex, 1);
					let reserveElements = response.data.accountStructure.ReserveElementMap.split('.');
					reserveElements.splice(response.data.accountStructure.ReserveElementFundIndex, 1);
					let revenueElements = response.data.accountStructure.RevenueElementMap.split('.');
					revenueElements.splice(response.data.accountStructure.RevenueElementFundIndex, 1);
					let expenseElements = response.data.accountStructure.ExpenseElementMap.split('.');
					expenseElements.splice(response.data.accountStructure.ExpenseElementFundIndex, 1);

					model.elements = _.union(assetElements, liabilityElements, reserveElements, revenueElements, expenseElements);
				}

				return angular.noop;
			}
		}

		return angular.extend(model, {
			loadAccountStructures: _.partial(loadAccountStructures, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}
}
